import { observer } from "mobx-react-lite";

import { DOCUMENT_TYPES_TAB_KEY, WORK_TYPES_TAB_KEY, usePageStore } from "../reference-document-types-page.lib";
import { DocumentTypesTable } from "./document-types-table";
import { DocumentTypesToolbar } from "./document-types-toolbar";
import { WorkTypesTable } from "./work-types-table";
import { WorkTypesToolbar } from "./work-types-toolbar";

/** Контент вкладок «Справочники»: типы документов, виды работ или заглушка для нереализованных разделов. */
export const ReferenceContent = observer(() => {
  const store = usePageStore()!;

  if (store.activeTab === DOCUMENT_TYPES_TAB_KEY) {
    return (
      <>
        <DocumentTypesToolbar />
        <DocumentTypesTable />
      </>
    );
  }

  if (store.activeTab === WORK_TYPES_TAB_KEY) {
    return (
      <>
        <WorkTypesToolbar />
        <WorkTypesTable />
      </>
    );
  }

  return (
    <div className="flex min-h-[16rem] flex-col items-center justify-center gap-2 py-10 text-center">
      <p className="subtitle-base text-type-common">Раздел в разработке</p>
      <p className="paragraph-sm text-type-minor">Макеты раздела появятся отдельной задачей</p>
    </div>
  );
});
